export default __webpack_public_path__ + "static/media/fonts/AlegreyaSans-Black.5db15851.ttf";